import { EntityIcon } from '..';
import { TProps } from '../types/TProps';

const compactSizeClassName =
  'h-[35px] w-[35px] bg-[var(--color-avatar-bg)] text-sm leading-[35px] text-[var(--color-on-surface)]';

export const EntityIconCompact = ({ className, sizeClassName, ...props }: TProps) => (
  <EntityIcon {...props} sizeClassName={sizeClassName ?? compactSizeClassName} className={className} />
);
